import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom'
import Modal from "react-bootstrap/Modal";

function MomentsQbsComp() {
    let SERVER_URL = process.env.REACT_APP_API_URL;
    let BASE_URL = process.env.REACT_APP_APP_URL;
    let token = JSON.parse(localStorage.getItem('key'));
    const userId = localStorage.getItem('userId');

    const [modalstatus, setModalstatus] = useState(false);
    const [imgtitle, setImgtitle] = useState('');
    const [err, setErr] = useState('');
    const [errmsg, setErrmsg] = useState('');

    const [msg, setSmg] = useState('');

    const [errimgmsg, setImgerrmsg] = useState('');
    const [image, setImage] = useState('')
    const [qbsmoments, setQbsmoments] = useState([]);

    const get_oermission_data = useSelector((state) => state);
    const extract_permissions = get_oermission_data.login_Permission.permissions ? JSON.parse(get_oermission_data.login_Permission.permissions) : '';
    const hr_permission = get_oermission_data.login_Permission.permissions

    const showModal = () => {
        setModalstatus(true)
    }

    useEffect(() => {
        getMoments()
    }, [])
    const getMoments = async () => {
        const response = await fetch(SERVER_URL + `api/moments`,
            {
                method: 'GET',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
            })
            .then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setQbsmoments(data.result)
                }
            });

    }

    const handleClose = () => {
        setModalstatus(false)
        setImage('')
        setImgtitle('')
        setErr('')
        setErrmsg('')
        setImgerrmsg('')
        setSmg('')
    }
    const handleSubmit = () => {
        setErr('')
        setErrmsg('')
        setImgerrmsg('')
        if (imgtitle == '' || imgtitle == null || imgtitle == undefined) {
            setErr('red')
            setErrmsg(' Is Required')
            return false
        }
        else if (image == '' || image == null || image == undefined) {
            setErr('red')
            setImgerrmsg(' Is Required')
        }
        else {
            addNews()
        }

    }
    const handlefile = async (e) => {
        const file = e.target.files[0]
        setImage(file);
    }
    function addNews() {
        const formdata = new FormData();
        formdata.append('title', imgtitle);
        formdata.append('requestBy', userId);
        formdata.append('imagemoment', image);

        const response = fetch(SERVER_URL + `api/moments/add-moment/`,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: formdata,
            }).then(res => res.json())
            .then(data => {
                if (data.status == true) {
                    setErr('green');
                    setSmg('Qbs Moment Successfully Added.');
                    setTimeout(function () {
                        getMoments()
                        handleClose()
                    }, 1000);
                }
            })
    }
    const HandleDelete = (id) => {
        const user_login_id = localStorage.getItem('userId')
        const response = fetch(SERVER_URL + `api/moments/delete-moment`,
            {
                method: 'PUT',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'authorization': `bearer ${token.value}`
                },
                body: JSON.stringify({
                    id: id,
                    deleted: '1',
                    requestBy: user_login_id
                }),
            }).then(res => res.json())
            .then(data => {
                getMoments()
            })
    }

    return (
        <>
            <Modal show={modalstatus} size="md" id="confirm_login">
                <div className="modal-body">
                    <button type="button" className="float-end btn_close" onClick={handleClose} aria-label="Close">
                        <i className="icon icon-cross"></i>
                    </button>
                    <div className="dash_white_box_ttl text-center" id="exampleModalLabel">Add Image</div>
                    <div className="mb-2">
                        <label className="col-form-label">Image Title :<span style={{ color: err }}>{errmsg}</span></label>
                        <input type="text" onChange={(e) => { setImgtitle(e.target.value) }} className="form-control" />
                    </div>
                    <div className="mb-3">
                        <label className="col-form-label">Upload Image:<span style={{ color: err }}>{errimgmsg}</span></label>
                        <div className="input-group">
                            <input type="file" name="file" onChange={handlefile} required="" className="form-control" id="inputGroupFile01" />
                            <input type="submit" className="btn_7" value="Upload" name="upload" />
                        </div>
                    </div>
                    <div className="modalfooter">
                        <span style={{ color: err }}>{msg}</span>
                        <button type="button" className="btn_6 float-end ml10" onClick={handleClose}>Cancel</button>
                        <button type="button" onClick={handleSubmit} className="btn_5 float-end ">Submit</button>
                    </div>
                </div>
            </Modal>
            <div className="page-header">
                <h1>
                    {
                        (hr_permission?.includes('34') && <button className="btn_5 mt05 float-end" onClick={showModal}>Add Moments Photo</button>)
                    }

                    Moments at QBS</h1>
                <ul id="breadcrumbs" className="breadcrumb mb00">
                    <li>
                        <Link to="/dashboard">Dashboard </Link>
                    </li>
                    <li className="current">
                        <span>/</span> Moments at QBS
                    </li>
                </ul>
            </div>
            <div className="row_bg">
                <div className="mb-4 wp100">
                    <table className="table_style_1">
                        <thead>
                            <tr>
                                <th style={{ width: "80px" }}>S.No</th>
                                <th style={{ width: "400px" }}>Image</th>
                                <th>Image Title</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                qbsmoments.map((item, ind) => {
                                    return <tr key={ind}>
                                        <td>{ind + 1}</td>
                                        <td>
                                            <img src={`${SERVER_URL + "moments/" + item?.moment_image}`} className="images_sty_2" />
                                        </td>
                                        <td>{item.title}</td>
                                        <td>
                                            {
                                                (hr_permission?.includes('35') && <button onClick={(e) => { HandleDelete(item?.momentID) }} className="btn_8">Delete</button>)
                                            }
                                        </td>
                                    </tr>
                                })
                            }

                        </tbody>
                    </table>

                </div>
            </div>
        </>
    )
}

export default MomentsQbsComp
